import { getEnv } from "@umami/utils";

const devEnv = getEnv("DEV");
const nodeEnv = getEnv("NODE_ENV");

export const IS_DEV = !!devEnv || nodeEnv === "development";
export const HOTJAR_SITE_ID = IS_DEV ? 5317676 : 5317317;
export const SENTRY_DSN_KEY =
  "https://e7bc719ce82c18b755be2d41a3088939@o4508292333830144.ingest.us.sentry.io/4508858621689856";

// PostHog configuration
export const POSTHOG_API_KEY = getEnv("VITE_PUBLIC_POSTHOG_KEY") ?? "";
export const POSTHOG_HOST = "https://us.i.posthog.com";
